import React from "react";

export default function WeatherForecastDay(props) {
  function day() {
    let date = new Date(props.forecastData.time * 1000);
    let day = date.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return days[day];
  }

  return (
    <div className="WeatherForecast">
      <div className="WeatherForecast-day">{day()}</div>
      <img
        src={props.forecastData.condition.icon_url}
        alt={props.forecastData.condition.description}
        width={40}
        height={40}
      ></img>
      <div className="WeatherForecast-temperatures">
        <span className="WeatherForecast-temperature-max">
          {Math.round(props.forecastData.temperature.maximum)}°
        </span>
        <span className="WeatherForecast-temperature-min">
          {Math.round(props.forecastData.temperature.minimum)}°
        </span>
      </div>
    </div>
  );
}
